import { useTranslation } from 'react-i18next'

import { type Err } from '../CreateGroup/useCreateCampaignGroup'

import { ActionModal, Modal } from '@percent/lemonade'
import { useArchiveCampaignGroup } from './useArchiveCampaignGroup'

export type ArchiveGroupModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
  group: { id: string; name: string }
  onSuccess: () => void
  onError: (error?: Err) => void
}>

export function ArchiveGroupModal({ isOpen, handleClose, group, onSuccess, onError }: ArchiveGroupModalProps) {
  const { t } = useTranslation()

  const { isLoading, archiveGroup } = useArchiveCampaignGroup({
    onArchived: () => {
      onSuccess()
    },
    onError: (error: Err) => {
      onError(error)
    }
  })

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ActionModal
        title={t('typography.archiveGroupTitle')}
        primaryButtonText={t('button.archiveGroup')}
        secondaryButtonText={t('button.cancel')}
        handleClose={handleClose}
        handleSubmit={() => archiveGroup(group.id)}
        loading={isLoading}
      >
        {t('typography.archiveGroupDescription')}
      </ActionModal>
    </Modal>
  )
}
